import { render, staticRenderFns } from "./ManageMulti.vue?vue&type=template&id=0a522e83&"
import script from "./ManageMulti.vue?vue&type=script&lang=js&"
export * from "./ManageMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports